module.exports = __webpack_public_path__ + "img/new-event-type.efc43322.png";